import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const NavbarBrand = styled(Link)`
    
`;

export const NavbarSlogan = styled.div`
  flex: 1;
  color: white;
  white-space: nowrap;
  font-weight: bold;
  font-size: 16px;
  
  @media (max-width: 1280px) {
    display: none;
  }
  span{
    color: #3282F7;
  }
`;